import { fadeOutStep } from "./stepAnimations";


/**
 * 
 * @param {Product365} product365 
 * @param {Product} product 
 * @param {Cart} cart 
 */
export function initPlaces(product365, product, cart) {
    let continueFormButtons = document.querySelectorAll(".form-question-col.places .continue-form-button") ? document.querySelectorAll(".form-question-col.places .continue-form-button") : null;
    if (continueFormButtons) {
        for (let continueFormButton of continueFormButtons) {

            continueFormButton.addEventListener("click", (e) => {
                e.preventDefault();
                
                let placesAmount = document.querySelectorAll(".cloudmanufaktur-form-field-amount-inner input")[0].dataset.value;
                product.updatePlaces(placesAmount)
                console.log(product)

                cart.addProduct(product);
                cart.saveCartToLocalStorage();
                let formStepHolder = document.getElementById("form-question-places")
                fadeOutStep(formStepHolder.parentElement);


                window.history.pushState({}, "", cloudmanufaktur.cartUrl)
                history.go(0)

            })


        }
    }

}